module.exports = __webpack_public_path__ + "img/sct3.1ccda73a.png";